import { SubjectData } from 'shell/models/person';
import { CitizenshipVM } from 'shell/view-models/citizenship';
import { DateTime } from 'luxon';

export const transformCitizenship = (person: SubjectData): Array<CitizenshipVM> | undefined => {
  const originReturnData: Array<CitizenshipVM> | undefined = person?.cittadinanza
    ? person.cittadinanza.map((citizen) => ({
        code: citizen.codiceStato || '',
        citizenship: citizen.descrizioneStato || '',
        note: citizen.noteStato || '',
        validityDate: citizen.dataValidita
          ? DateTime.fromISO(citizen.dataValidita).toFormat('dd/MM/yyyy')
          : '',
        state: citizen.codiceStato
          ? {
              id: citizen.codiceStato,
              code: citizen.codiceStato,
              value: citizen.descrizioneStato || '',
            }
          : undefined,
      }))
    : undefined;

  return originReturnData;
};
